import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_arrange_health_checks_for_all_wrkrs_und_the_age'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_arrange_health_checks_for_all_wrkrs_und_the_age',
  name: 'Does the facility arrange health checks for all workers under the age of 18?',
  description:
    'The intent of this question is to understand if the facility (regardless of what the law states) arranges health checks for all young workers to ensure that the physical demands of the job do not affect the young worker’s physical and mental development.\r\r\n\r\r\n"Health checks" (or "medical checks") refers to examination by medical professional (s).\r\r\n \r\r\n"Arrange" refers to the facility setting up the health checks on behalf of the worker.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'cl-4--5',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 4530,
  sectionId: '2.2.1',
  impactArea: 'Child Labour',
  impactAreaId: 'CHILD_LABOR',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
